(function(){
  // Categories dropdown
  var btn = document.getElementById('catBtn');
  var panel = document.getElementById('catPanel');
  if(btn && panel){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      panel.classList.toggle('open');
    });
    document.addEventListener('click', function(e){
      if(!panel.contains(e.target) && e.target !== btn){
        panel.classList.remove('open');
      }
    });
  }

  // Nav active-state highlight
  document.querySelectorAll('nav.main a').forEach(function(link){
    link.addEventListener('click', function(){
      document.querySelectorAll('nav.main a').forEach(function(l){ l.classList.remove('active'); });
      link.classList.add('active');
    });
  });

  // Real Shopify Ajax add-to-cart for every "product" form on the page
  // (weekly offers grid + flash offer). Falls back to a normal form post
  // if the fetch fails.
  document.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btnEl = form.querySelector('.js-add-to-cart');
      var original = btnEl ? btnEl.textContent : null;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ return fetch('/cart.js'); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var countEl = document.getElementById('cartCount');
        var iconEl = document.getElementById('cartIcon');
        if(countEl) countEl.textContent = cart.item_count;
        if(iconEl){
          var priceText = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';
          iconEl.innerHTML = '🛒 <span class="badge" id="cartCount">' + cart.item_count + '</span> ' + priceText;
        }
        if(btnEl){
          btnEl.textContent = '✓';
          setTimeout(function(){ btnEl.textContent = original; }, 900);
        }
      })
      .catch(function(){ form.submit(); });
    });
  });
})();
